module.exports = __webpack_public_path__ + "img/zalo.2d9ed112.png";